import { useState } from "react";

const faqs = [
  {
    id: 1,
    q: "第一次參加，完全不認識任何人，會很尷尬嗎？",
    a: "完全不用擔心！紅歡密的每場活動都有精心設計的破冰環節，主持人會帶領大家自然地認識彼此。我們的參與者大多是單獨報名，反而更容易交到真心朋友。很多人第一次來就說「比想像中好太多了！」",
  },
  {
    id: 2,
    q: "活動費用包含哪些？有隱藏費用嗎？",
    a: "每場活動的費用說明都清楚列在詳情頁的「費用包含」區塊，絕對沒有隱藏費用。以露營活動為例，費用通常包含一泊三食、全套露營裝備、所有活動材料與保險。報名前可以仔細查看，有疑問也歡迎私訊我們！",
  },
  {
    id: 3,
    q: "如果臨時有事不能參加，可以退費嗎？",
    a: "我們理解突發狀況難以避免。一般來說，活動前 7 天以上取消可退還 80% 費用；3-7 天內取消退還 50%；3 天內恕不退費。詳細退費政策請在報名前確認，或直接私訊我們的 Instagram @rappy.meme 詢問。",
  },
  {
    id: 4,
    q: "活動適合什麼年齡層？有年齡限制嗎？",
    a: "不同活動有不同的適合對象！社交聯誼和讀書會主要面向 20-40 歲的成年人；親子活動則歡迎全家大小（建議孩子 4-12 歲）；露營活動老少皆宜。每場活動的詳情頁都有「適合對象」說明，可以對照看看。",
  },
  {
    id: 5,
    q: "我可以帶朋友一起參加嗎？",
    a: "當然歡迎！帶朋友一起來更熱鬧。不過要注意部分活動名額有限，請各自完成報名以確保名額。如果是情侶或好友想要相鄰座位，可以在備註欄說明，我們會盡量安排。",
  },
  {
    id: 6,
    q: "工商合作怎麼洽談？費用怎麼計算？",
    a: "工商合作的費用依服務項目、規模和需求而定，沒有固定價格表。最快的方式是私訊我們的 Instagram @rappy.meme，或填寫工商合作頁的洽談表單，說明你的需求，我們會在 24 小時內回覆並提供報價。",
  },
  {
    id: 7,
    q: "應徵直播主需要什麼條件？真的零經驗也可以嗎？",
    a: "真的！我們歡迎零經驗的新人。只要你有親和力、愛聊天，或有歌唱、舞蹈、樂器等才藝，都可以來試試。我們提供完整的形象攝影、直播技巧教學，從設備設定到互動技巧手把手教學，讓你快速上手。",
  },
];

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggle = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="py-20 md:py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-20">

          {/* Left: Header */}
          <div className="lg:col-span-2">
            <p className="text-red-600 text-sm font-semibold tracking-widest uppercase mb-3">
              FAQ
            </p>
            <h2
              className="text-3xl md:text-4xl font-black text-gray-900 mb-5 leading-tight"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              常見問題
              <br />
              <span className="text-red-600">一次解答</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              還有其他疑問？隨時私訊我們，
              <br />
              紅歡密團隊 24 小時內回覆！
            </p>

            {/* Contact shortcuts */}
            <div className="flex flex-col gap-3">
              <a
                href="https://www.instagram.com/rappy.meme/"
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center gap-3 px-5 py-3 rounded-xl bg-white border border-gray-100 text-gray-700 text-sm font-medium hover:border-red-300 hover:text-red-600 transition-all duration-200 cursor-pointer group"
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-50 text-red-600 group-hover:bg-red-600 group-hover:text-white transition-all duration-200">
                  <i className="ri-instagram-line text-base" />
                </span>
                私訊 Instagram @rappy.meme
              </a>
              <a
                href="https://lin.ee/wpeGAKJ"
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center gap-3 px-5 py-3 rounded-xl bg-white border border-gray-100 text-gray-700 text-sm font-medium hover:border-green-300 hover:text-green-600 transition-all duration-200 cursor-pointer group"
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-green-50 text-green-600 group-hover:bg-green-600 group-hover:text-white transition-all duration-200">
                  <i className="ri-line-fill text-base" />
                </span>
                加入官方 LINE 詢問
              </a>
              <a
                href="mailto:red.shrimp.close@gmail.com"
                className="inline-flex items-center gap-3 px-5 py-3 rounded-xl bg-white border border-gray-100 text-gray-700 text-sm font-medium hover:border-red-300 hover:text-red-600 transition-all duration-200 cursor-pointer group"
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-50 text-red-600 group-hover:bg-red-600 group-hover:text-white transition-all duration-200">
                  <i className="ri-mail-line text-base" />
                </span>
                寄信給我們
              </a>
            </div>
          </div>

          {/* Right: Accordion */}
          <div className="lg:col-span-3 flex flex-col gap-3">
            {faqs.map((faq) => {
              const isOpen = openId === faq.id;
              return (
                <div
                  key={faq.id}
                  className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                    isOpen
                      ? "border-red-200 bg-white"
                      : "border-gray-100 bg-white hover:border-red-100"
                  }`}
                >
                  <button
                    onClick={() => toggle(faq.id)}
                    className="w-full flex items-start justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                  >
                    <span
                      className={`font-semibold text-sm md:text-base leading-snug transition-colors duration-200 ${
                        isOpen ? "text-red-600" : "text-gray-800"
                      }`}
                    >
                      {faq.q}
                    </span>
                    <span
                      className={`w-6 h-6 flex items-center justify-center rounded-full shrink-0 mt-0.5 transition-all duration-300 ${
                        isOpen
                          ? "bg-red-600 text-white rotate-45"
                          : "bg-gray-100 text-gray-500"
                      }`}
                    >
                      <i className="ri-add-line text-sm" />
                    </span>
                  </button>

                  {/* Answer */}
                  <div
                    className={`transition-all duration-300 ease-in-out overflow-hidden ${
                      isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                    }`}
                  >
                    <p className="px-6 pb-5 text-gray-500 text-sm leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </div>
    </section>
  );
}
